
// import { Phrase } from "./Phrase";

import * as api from '@/libs/api.js';

import { store } from '@/libs/db.js';

/*

The goal students are trying to meet, is to learn whole phrases. They do this
by learning other phrases that are easy enough (for them) to understand, but
_just_ hard enough to learn something new from. To decide on how difficult a
phrase is, the phrase is broken down into words, and each word is assigned
its own difficulty score. This score is determined by searching through all
other phrases, and tallying up how many times a phrase containing that word
was successfully recalled. The more tallies, the less difficult. If a word
was studied successfully in _two_ different phrases, then the word is
considered to be "known".

By design, only phrases with _one_ non-known word can be put into the "deck".

- unknown:  you've never studied the word
- familiar: you've studied the word before, but can't necessarily recall it
- known:    you can be expected to recall the word
*/

export class Word {

  constructor(text) {
    this.text = text;
  }

  async getEffectiveWordComplexity() {
    // TODO: move `isWordMarkedAsKnown` to the store and cache results
    if (await api.isWordMarkedAsKnown(this)) {
      return 0;
    }
    let wordSuccesses = await this.getWordSuccesses();
    if (wordSuccesses < 2) {
      return 1;
    }
    return 0;
  }

  async getWordSuccesses() {
    let wordSuccesses = 0;
    const relatedItems = await this.getItemsWithWord();
    for (let relatedItem of relatedItems) {
      if (relatedItem.getSuccessDays() >= 2) {
        wordSuccesses += 1;
      }
    }
    return wordSuccesses;
  }

  async getItemsWithWord() {
    const matchingItems = [];

    for (let item of store.getters.reviewItems) {
      if (item.phrase.containsWord(this)) {
        matchingItems.push(item);
      }
    }
    return matchingItems;
  }

}